module.exports = __webpack_public_path__ + "static/img/bg_business.b43855e8.png";